<app-todo
    [label]="'LEAVER_NOT_INTERESTED' | i18nKeyTranslate: i18nKeys.ServiceAction"
    [state]="todoState.Warning"
    [warning]="true"
    [muted]="true"
>
</app-todo>
